<template>
  <div class="webinar-widget">
    <div
      v-if="showBanner"
      class="webinar-widget__banner"
    >
      <img
        src="../../../assets/images/materials/webinar-countdown-bg.webp"
        alt="image"
      >

      <div class="webinar-widget__banner--text">
        <h4>
          {{ bannerTitle }}
        </h4>

        <p v-if="showCountdown">
          {{ countdown }}
        </p>

        <button
          v-if="showBannerRegButton"
          @click="$emit('signUpToWebinar')"
        >
          смотреть вебинар
        </button>
      </div>
    </div>

    <div
      v-if="userRegisterOnWebinar && (isWebinarInProgress || webinarHasEnded)"
      class="webinar-widget__iframe"
    >
      <iframe
        width="100%"
        height="460px"
        :src="webinarUrl"
        frameBorder="0"
        allow="clipboard-write; autoplay"
        allowFullScreen
      />
    </div>

    <div
      v-if="haveLeadId && userRegisterOnWebinar && (isWebinarInProgress || webinarHasEnded)"
      class="webinar-widget__iframe_button"
    >
      <button
        class="m-btn"
        @click="$emit('chooseCourse')"
      >
        Подобрать курс
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebinarWidget',
  props: {
    webinarData: { type: Object, default: () => ({}) },
    userRegisterOnWebinar: { type: [Object, Boolean], default: null },
  },
  data: () => ({
    now: new Date(),
    interval: null,
  }),
  computed: {
    haveLeadId() {
      return this.userRegisterOnWebinar?.currentMember?.marketingLead?.id;
    },
    isWebinarInProgress() {
      return this.now >= new Date(this.webinarData?.startDate)
        && this.now <= new Date(this.webinarData?.endDate);
    },
    webinarHasNotStarted() {
      return this.now < new Date(this.webinarData?.startDate);
    },
    webinarHasEnded() {
      return this.now > new Date(this.webinarData?.endDate);
    },
    showBanner() {
      return this.webinarHasNotStarted
        || (this.webinarHasEnded && !this.userRegisterOnWebinar)
        || (this.isWebinarInProgress && !this.userRegisterOnWebinar);
    },
    bannerTitle() {
      if (!this.showBanner) {
        return null;
      }
      if (this.isWebinarInProgress && !this.userRegisterOnWebinar) {
        return 'зарегистрируйтесь, чтобы смотреть вебинар';
      }
      if (this.webinarHasEnded && !this.userRegisterOnWebinar) {
        return 'зарегистрируйтесь, чтобы смотреть вебинар';
      }
      if (this.webinarHasNotStarted) {
        return 'вебинар начнется через:';
      }

      return null;
    },
    showCountdown() {
      return new Date(this.webinarData?.startDate) > this.now;
    },
    countdown() {
      const diff = new Date(this.webinarData?.startDate) - this.now;
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
      const days = Math.floor(diff / 1000 / 60 / 60 / 24);
      const seconds = Math.floor((diff / 1000) % 60);

      const resultArr = [];

      if (days > 0) {
        resultArr.push(`${days} ${this.getDeclension(days, ['день', 'дня', 'дней'])}`);
      }
      if (days > 0 || hours > 0) {
        const formattedDays = days ? String(hours).padStart(2, '0') : hours;
        resultArr.push(`${formattedDays} ${this.getDeclension(hours, ['час', 'часа', 'часов'])}`);
      }
      if (days > 0 || hours > 0 || minutes > 0) {
        const formattedMinutes = days || hours ? String(minutes).padStart(2, '0') : minutes;
        resultArr.push(`${formattedMinutes} ${this.getDeclension(minutes, ['минута', 'минуты', 'минут'])}`);
      }
      if (!days && !hours && !minutes && seconds) {
        resultArr.push(`${seconds} ${this.getDeclension(seconds, ['секунда', 'секунды', 'секунд'])}`);
      }

      if (resultArr.length) {
        return resultArr.join(' ');
      }
      return null;
    },
    showBannerRegButton() {
      return (this.isWebinarInProgress && !this.userRegisterOnWebinar)
        || (this.webinarHasEnded && !this.userRegisterOnWebinar);
    },
    webinarUrl() {
      return this.webinarData?.externalSourceLink;
    },
  },
  watch: {
    countdown(newVal) {
      if (!newVal) {
        setTimeout(() => {
          clearInterval(this.interval);
        }, 1000);
      }
    },
    webinarHasNotStarted: {
      immediate: true,
      handler(value) {
        if (value) {
          this.interval = setInterval(this.updateTime, 1000);
        }
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    getDeclension(number, words) {
      const cases = [2, 0, 1, 1, 1, 2];
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    updateTime() {
      this.now = new Date();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Onest:wght@100..900&display=swap');

.webinar-widget {
  &__banner {
    position: relative;

    border-radius: calc(var(--scale) * 20);

    @include media-down($size-mobile) {
      height: calc(var(--scale) * 233);
      overflow: hidden;
    }

    img {
      display: block;
      width: 100%;

      @include media-down($size-mobile) {
        min-height: 100%;
      }
    }

    &--text {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h4 {
        max-width: calc(var(--scale) * 567);

        font-family: 'Onest', sans-serif;
        font-size: calc(var(--scale) * 52);
        font-weight: 500;
        line-height: 90%;
        letter-spacing: -0.06em;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: $white-color;

        @include media-down($size-mobile) {
          max-width: calc(var(--scale) * 318);

          font-size: calc(var(--scale) * 22);
          line-height: 120%;
        }
      }

      p {
        margin-top: calc(var(--scale) * 12);

        font-family: 'Onest', sans-serif;
        font-size: calc(var(--scale) * 20);
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -0.02em;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: $white-color;

        @include media-down($size-mobile) {
          margin-top: calc(var(--scale) * 4);

          font-size: calc(var(--scale) * 16);
          line-height: 130%;
        }
      }

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(var(--scale) * 396);
        height: calc(var(--scale) * 122);
        margin-top: calc(var(--scale) * 24);

        border: none;
        border-radius: calc(var(--scale) * 40);
        background-color: #5237E6;
        box-shadow: 4px 4px 20px 0 rgba(#071539, .05), 10px 10px 50px 0 rgba(#071539, .01);

        font-size: calc(var(--scale) * 32);
        font-weight: 500;
        line-height: 110%;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: $white-color;

        cursor: pointer;
        transition: background-color .2s ease-out;

        &:hover {
          background-color: lighten(#5237E6, 5%);
        }

        @include media-down($size-mobile) {
          width: calc(var(--scale) * 318);
          height: calc(var(--scale) * 80);
          margin-top: calc(var(--scale) * 24);

          border-radius: calc(var(--scale) * 24);

          font-size: calc(var(--scale) * 18);
        }
      }
    }
  }

  &__iframe {
    display: block;
    height: 460px;
    overflow: hidden;
    border-radius: calc(var(--scale) * 20);

    @include media-down($size-mobile) {
      height: 233px;

      iframe {
        height: 233px !important;
      }
    }

    &_button {
      text-align: center;

      button {
        margin: 23px auto 0;
        padding: 30px 56px;
        background-color: #FF5319;
        border-radius: 24px;
        transition: 200ms;

        font-family: 'Onest', sans-serif;
        font-weight: 500;
        font-size: 18px;
        line-height: 110%;
        letter-spacing: -0.02em;
        color: #FFFFFF;

        &:hover {
          background-color: #FF9C12;
        }
      }
    }
  }
}
</style>
